import axios from "axios";
import { baseURL } from "../../../base-url.js";
import { buildSaleRequest } from "../../../utility/discount-service";

const toErrorResponse = error => error?.response ?? {
  status: 0,
  data: error?.message ?? "Wystąpił błąd podczas obsługi sprzedaży."
};

export default {
  async createSale({ commit }, saleData) {
    const token = localStorage.getItem("jwt");

    try {
      const response = await axios.post(baseURL + "/sale/createSale", buildSaleRequest(saleData), {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (response.status >= 200 && response.status < 300) commit('product/salesStockChanged', null, { root: true });
      return response;
    } catch (error) {
      return toErrorResponse(error);
    }
  },

  async updateSale({ commit }, saleData) {
    const token = localStorage.getItem("jwt");

    try {
      const response = await axios.put(baseURL + "/sale/updateSale", buildSaleRequest(saleData), {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      // Employee-only edits also change the names stored in stock history.
      if (response.status >= 200 && response.status < 300) commit('product/salesStockChanged', null, { root: true });
      return response;
    } catch (error) {
      return toErrorResponse(error);
    }
  },

  async loadSalesToday({ commit }, salonId) {
    const token = localStorage.getItem("jwt");

    try {
      const response = await axios.get(`${baseURL}/sale/getSalonAllSalesToday`, {
        params: { salonId },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      commit("setSales", response.data);
    } catch (error) {
      console.error("Błąd ładowania dzisiejszych transakcji:", error);
    }
  },

  async loadSalonSalesByDate({ commit }, params) {
    const token = localStorage.getItem("jwt");

    try {
      const response = await axios.get(`${baseURL}/sale/getSalonAllSalesByDate`, {
        params: {
          salonId: params.salonId,
          startDate: params.startDate,
          endDate: params.endDate
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      commit("setSales", response.data);
    } catch (error) {
      console.error("Błąd ładowania transakcji:", error);
    }
  },

  async loadSalonEmployeeAdvances({ commit }, { salonId, startDate, endDate }) {
    const token = localStorage.getItem("jwt");

    try {
      const response = await axios.get(`${baseURL}/sale/getSalonAdvances`, {
        params: { startDate, endDate, salonId },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      commit("setSales", response.data);
    } catch (error) {
      console.error("Błąd ładowania dzisiejszych transakcji:", error);
    }
  }
  
}
